import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { EappBeneficiaryGateway } from '../gateways/EAppEnrollment-gateway'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { EappUpdateStatus } from '../models/beneficiary-status-model'
import { PortalGlobals } from '../../portalglobals'
@Component({
    selector: 'EAppEnrollmentMessage',
    templateUrl: 'e-app-verify-messages.component.html',
    styleUrls: ['./EApp-beneficiary.component.scss']
})
export class EAppEnrollmentMessagesComponent implements OnInit, OnDestroy {
    id: string
    appReject: boolean = false
    emailSent: boolean = false
    urlExpire: boolean = false
    appCorrection: boolean = false
    finalSubmit: boolean = false
    AfterfinalSubmit: boolean = false
    hasError: boolean
    ErrorMessages: any[]
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    eappUpdateStatusModel: EappUpdateStatus = {} as EappUpdateStatus
    logoPath: string
    public insurance: string
    icid: string
    insCoId: number

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _enrollmentGateway: EappBeneficiaryGateway,
        private _global: PortalGlobals
    ) {}
    ngOnInit() {
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        //this.insurance = this._global.currentUser.insuranceCompanyName
        this.getParams()
        this.getLogoPath()
        if (this.id === '1') {
            this.emailSent = true
            this.appReject = false
            this.urlExpire = false
            this.appCorrection = false
            this.finalSubmit = false
            this.AfterfinalSubmit = false
        } else {
            if (this.id === '2') {
                this.appReject = true
                this.emailSent = false
                this.urlExpire = false
                this.appCorrection = false
                this.finalSubmit = false
                this.AfterfinalSubmit = false
            }
            if (this.id === '3') {
                this.appReject = false
                this.emailSent = false
                this.urlExpire = true
                this.appCorrection = false
                this.finalSubmit = false
                this.AfterfinalSubmit = false
            }
            if (this.id === '4') {
                this.appReject = false
                this.emailSent = false
                this.urlExpire = false
                this.appCorrection = true
                this.finalSubmit = false
                this.AfterfinalSubmit = false
            }
            if (this.id === '5') {
                this.appReject = false
                this.emailSent = false
                this.urlExpire = false
                this.appCorrection = false
                this.finalSubmit = true
                this.AfterfinalSubmit = false
                if (this.enrollmentViewModel.INSURANCECOMPID !== undefined) {
                    this.insCoId = this.enrollmentViewModel.INSURANCECOMPID
                } else {
                    this.insCoId = 0
                }
                this.enrollmentViewModel = {} as EnrollmentViewModel
                this.enrollmentViewModel.INSURANCECOMPID = this.insCoId
                this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            }
            if (this.id === '6') {
                this.appReject = false
                this.emailSent = false
                this.urlExpire = false
                this.appCorrection = false
                this.finalSubmit = false
                this.AfterfinalSubmit = true

                if (this.enrollmentViewModel.INSURANCECOMPID !== undefined) {
                    this.insCoId = this.enrollmentViewModel.INSURANCECOMPID
                } else {
                    this.insCoId = 0
                }
                this.enrollmentViewModel = {} as EnrollmentViewModel
                this.enrollmentViewModel.INSURANCECOMPID = this.insCoId
                this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            }
        }
    }
    getParams() {
        this.route.params.forEach((params: Params) => {
            this.id = this.route.snapshot.params['id']
            this.icid = this.route.snapshot.params['icid']
        })
    }
    getLogoPath() {
        console.log('getLogoPath Begin')
        if (
            this.enrollmentViewModel === undefined ||
            this.enrollmentViewModel === null ||
            this.enrollmentViewModel.INSURANCECOMPID === undefined ||
            this.enrollmentViewModel.INSURANCECOMPID === null ||
            this.enrollmentViewModel.INSURANCECOMPID === 0
        ) {
            this.enrollmentViewModel.INSURANCECOMPID = Number(this.icid)
        }

        this._enrollmentGateway.getLogoPath(this.enrollmentViewModel.INSURANCECOMPID, this.enrollmentViewModel.PLANYEAR)?.subscribe(
            (res) => {
                this.logoPath = res
                console.log('Image logo path :' + this.logoPath)
                this.enrollmentViewModel = {} as EnrollmentViewModel
                this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            },
            (error) => (this.logoPath = error)
        )
    }
    viewHistory() {
        this.router.navigate(['/enrollment/e-application/history'])
    }

    ngOnDestroy() {
        if (this.id === '5' || this.id === '6') {
            this.router.navigate(['/messages/6/' + this.insCoId])
        }
    }
}
